module.exports = __webpack_public_path__ + "static/media/3.80ad58bb.svg";